<div class="vbox-space">
  <div class="hbox" style="border-bottom: 1px solid darkgrey" *ngFor="let notif of notifService.notifications">
    <mat-icon *ngIf="notif.icon" class="icon-small">{{notif.icon}}</mat-icon> <div class="mono">{{notif.title}}</div>
  </div>
</div>
